import { useTranslation } from 'react-i18next';
import FilterChip from '@/components/filter-chip/filter-chip';
import { ISO_WEEKDAYS } from '@/services/outbound-calls-service/outbound-calls.constants';
import styles from './outbound-calls.module.scss';

interface WeekdayChipsProps {
  /** ISO weekdays, Monday = 1. Form.Item hands `value` and `onChange` in. */
  value?: number[];
  onChange?: (days: number[]) => void;
  label: string;
}

/** A day per toggle chip, for `call_days` and `work_days`. */
export function WeekdayChips({ value = [], onChange, label }: WeekdayChipsProps) {
  const { t } = useTranslation('outbound');

  const toggle = (day: number) =>
    onChange?.(
      value.includes(day)
        ? value.filter((picked) => picked !== day)
        : [...value, day].sort((a, b) => a - b)
    );

  return (
    <div role="group" aria-label={label} className={styles.chips}>
      {ISO_WEEKDAYS.map((day) => (
        <FilterChip
          key={day}
          label={t(`weekdays.${day}`)}
          active={value.includes(day)}
          onClick={() => toggle(day)}
        />
      ))}
    </div>
  );
}
